export default function Button({
  onClick,
  className = "btn",
  children,
}) {
  if (typeof onClick !== "function")
    console.debug(`A button "${children}" doesn't have an onClick callback`);

  const handleClick = (event) => {
    event.preventDefault();

    if (typeof onClick === "function")
      onClick();
  };
  return (<button className={className} onClick={handleClick}>{children}</button>);
};
